import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { trackPageView } from "@/lib/analytics";

/**
 * Fires a GA4 `page_view` event on every client-side route change.
 *
 * Call once from a top-level component (see `Providers.tsx`). The matching
 * gtag.js snippet in `index.html` disables the automatic initial page_view so
 * this hook is the single source of truth for SPA navigation events.
 */
export const usePageViewTracking = (): void => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    trackPageView(pathname + search);
  }, [pathname, search]);
};
